import {Component, input, TemplateRef, contentChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CardModule} from 'primeng/card';
import {DataViewModule} from 'primeng/dataview';

@Component({
  selector: 'app-data-view-grid',
  imports: [CommonModule, CardModule, DataViewModule],
  templateUrl: './data-view-grid.component.html',
})
export class DataViewGridComponent<T> {
  readonly items = input.required<T[]>();
  readonly emptyMessage = input<string>('');
  readonly showPaginator = input<boolean>(true);
  readonly rows = input<number>(6);
  readonly showCard = input<boolean>(true);
  readonly gridCols = input<string>('grid-cols-1 md:grid-cols-2 lg:grid-cols-2');

  readonly itemTemplate = contentChild.required<
    TemplateRef<{
      $implicit: T;
    }>
  >('itemTemplate');
}
